import { memo } from 'react';
import type { Race } from '../../types';
import { formatDistance, sortDistances } from '../../utils/distance';
import { getDday } from '../../utils/dday';
import { formatKorDate } from '../../utils/dateRange';
import { STATUS_LABELS } from '../../utils/raceLabels';
import './RaceTooltip.css';

interface RaceTooltipProps {
  race: Race;
  position: { x: number; y: number };
}

const TOOLTIP_W = 220;
const TOOLTIP_H = 140;
const EDGE_OFFSET = 15;

function RaceTooltipInner({ race, position }: RaceTooltipProps) {
  const dday = getDday(race);
  const sorted = sortDistances(race.distances);
  const primary = sorted[sorted.length - 1];

  const viewportW = typeof window !== 'undefined' ? window.innerWidth : 1024;
  const viewportH = typeof window !== 'undefined' ? window.innerHeight : 768;
  const left =
    position.x + TOOLTIP_W + 20 > viewportW ? position.x - TOOLTIP_W - EDGE_OFFSET : position.x + EDGE_OFFSET;
  const top =
    position.y + TOOLTIP_H + 10 > viewportH ? position.y - TOOLTIP_H - 10 : position.y - 10;

  return (
    <div
      className={`race-tooltip status-${race.status}`}
      style={{ left, top }}
    >
      <div className="race-tooltip-top">
        <div className="race-tooltip-dday-group">
          <span className="race-tooltip-dday display">{dday.label}</span>
          {dday.caption && (
            <span className="race-tooltip-dday-caption">{dday.caption}</span>
          )}
        </div>
        <span className={`race-tooltip-status status-${race.status}`}>
          {STATUS_LABELS[race.status]}
        </span>
      </div>
      {primary && (
        <div className="race-tooltip-distance display">{formatDistance(primary)}</div>
      )}
      <div className="race-tooltip-title">{race.nameLocal || race.name}</div>
      <div className="race-tooltip-meta">
        <span>{race.city ?? race.region}</span>
        <span className="race-tooltip-dot" aria-hidden="true">·</span>
        <span>{formatKorDate(race.date, 'numeric-weekday')}</span>
      </div>
    </div>
  );
}

export const RaceTooltip = memo(RaceTooltipInner);
